/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const UniversalVideoPlayer = ({ videoUrl, isIlanDetay }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isShorts, setIsShorts] = useState(false);
  const [videoId, setVideoId] = useState("");
  const [platform, setPlatform] = useState("");

  const [loomEmbedData, setLoomEmbedData] = useState(null);

  useEffect(() => {
    if (platform === "loom" && videoId) {
      const oembedUrl = `https://www.loom.com/v1/oembed?url=https%3A%2F%2Fwww.loom.com%2Fshare%2F${videoId}&format=json`;

      fetch(oembedUrl)
        .then((response) => response.json())
        .then((data) => {
          setLoomEmbedData(data);
        })
        .catch((error) => { });
    }
  }, [platform, videoId]);

  useEffect(() => {
    const extractVideoInfo = (url) => {
      if (!url) {
        setVideoId("");
        setIsShorts(false);
        setPlatform("");
        return;
      }

      const videoIdRegExp = /^([a-f0-9-]{36})$/;
      const videoIdMatch = url.match(videoIdRegExp);

      if (videoIdMatch) {
        setPlatform("loom");
        setIsShorts(false);
        setVideoId(videoIdMatch[1]);
        return;
      }

      const loomBlobRegExp = /blob:https:\/\/www\.loom\.com\/([a-f0-9-]{36})/;
      const loomBlobMatch = url.match(loomBlobRegExp);

      if (loomBlobMatch && loomBlobMatch[1]) {
        setPlatform("loom");
        setIsShorts(false);
        setVideoId(loomBlobMatch[1]);
        return;
      }

      const loomRegExp = /(?:loom\.com\/share\/)([^#&?]*)/;
      const loomMatch = url.match(loomRegExp);

      if (loomMatch && loomMatch[1]) {
        setPlatform("loom");
        setIsShorts(false);
        setVideoId(loomMatch[1]);
        return;
      }

      const shortsRegExp =
        /(?:youtube\.com\/shorts\/|youtube\.com\/shorts\/)([^#&?]*)/;
      const shortsMatch = url.match(shortsRegExp);

      if (shortsMatch && shortsMatch[1].length === 11) {
        setPlatform("youtube");
        setIsShorts(true);
        setVideoId(shortsMatch[1]);
        return;
      }

      const youtubeRegExp =
        /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const youtubeMatch = url.match(youtubeRegExp);

      if (youtubeMatch && youtubeMatch[2].length === 11) {
        setPlatform("youtube");
        setIsShorts(false);
        setVideoId(youtubeMatch[2]);
        return;
      }

      // ✅ DİREKT VİDEO LİNKLERİ (MP4, WEBM vb.)
      const isDirectVideo = url.match(/\.(mp4|webm|ogg|mov|m4v)(?:\?.*)?$/i) ||
        url.includes('storage.googleapis.com') ||
        url.includes('/uploads/ofisler/');

      if (isDirectVideo) {
        setPlatform("direct");
        setIsShorts(false);
        setVideoId(url);
        return;
      }

      setPlatform("");
      setIsShorts(false);
      setVideoId("");
    };

    extractVideoInfo(videoUrl);
  }, [videoUrl]);

  const playVideo = () => {
    setIsPlaying(true);
  };

  const getThumbnailUrl = () => {
    if (platform === "youtube") {
      return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    } else if (platform === "loom") {
      return `https://cdn.loom.com/sessions/thumbnails/${videoId}-00001.jpg`;
    }
    return "";
  };

  const getEmbedUrl = () => {
    if (platform === "youtube") {
      return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    } else if (platform === "loom") {
      return `https://www.loom.com/embed/${videoId}?hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true&autoplay=1&muted=0&hide_speed=true&hide_watermark=true&hide_comments=true&hide_captions=true&hide_transcript=true`;
    }
    return "";
  };

  const getPlatformIcon = () => {
    if (platform === "youtube") {
      return "fa fa-play";
    } else if (platform === "loom") {
      return "fa fa-play-circle";
    }
    return "fa fa-play";
  };

  if (!videoId || !platform) {
    return (
      <div className="video-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center py-5">
              <div
                className="universal-card p-5 d-inline-block"
                style={{ background: "rgba(255,100,100,0.1)", borderRadius: "15px" }}
              >
                <i className="fas fa-exclamation-triangle text-danger mb-3" style={{ fontSize: "2rem" }}></i>
                <p style={{ color: "#d9534f", fontWeight: "600", marginBottom: 0 }}>
                  Geçersiz video URL'i veya desteklenmeyen format.
                </p>
                <small className="text-muted mt-2 d-block">
                  Lütfen geçerli bir Youtube, Loom veya .mp4 linki kullanın.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="video-content">
      <div className="container">
        <div className="row">
          <div
            className={isIlanDetay === undefined ? "col-lg-10 offset-lg-1" : ""}
          >
            <div
              className="universal-video-frame"
              style={{
                position: "relative",
                overflow: "hidden",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                width: "100%",
                margin: "0 auto",
                background: "#000",
              }}
            >
              {!isPlaying ? (
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    paddingBottom: "56.25%",
                    overflow: "hidden",
                    background: "#000",
                  }}
                >
                  <img
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: isShorts ? "auto" : "100%",
                      height: isShorts ? "100%" : "auto",
                      maxWidth: "none",
                    }}
                    src={platform === "direct" ? videoUrl : getThumbnailUrl()}
                    alt="Video thumbnail"
                    onError={(e) => {
                      if (platform === "youtube") {
                        e.target.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                      } else if (platform === "loom") {
                        if (e.target.src.includes("-00001.jpg")) {
                          e.target.src = `https://cdn.loom.com/sessions/thumbnails/${videoId}.jpg`;
                        } else if (
                          e.target.src.includes(".jpg") &&
                          !e.target.src.includes("-")
                        ) {
                          e.target.src = `https://cdn.loom.com/sessions/thumbnails/${videoId}-preview.jpg`;
                        } else {
                          e.target.src =
                            "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkyMCIgaGVpZ2h0PSIxMDgwIiB2aWV3Qm94PSIwIDAgMTkyMCAxMDgwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMTkyMCIgaGVpZ2h0PSIxMDgwIiBmaWxsPSIjZjBmMGYwIi8+Cjwvc3ZnPg==";
                        }
                      } else if (platform === "direct") {
                        e.target.style.display = 'none';
                        // Show a generic play icon if video thumb fails
                      }
                    }}
                  />

                  {platform === "direct" && !isPlaying && (
                    <div style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "rgba(0,0,0,0.3)"
                    }}>
                      <div style={{ color: 'white', textAlign: 'center' }}>
                        <i className="fa fa-play-circle" style={{ fontSize: '70px', opacity: 0.9 }}></i>
                      </div>
                    </div>
                  )}

                  {(platform === "youtube" || platform === "loom" || (platform === "direct" && !isPlaying)) && (
                    <a
                      onClick={playVideo}
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 10,
                        background:
                          platform === "loom" ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" :
                            platform === "youtube" ? "linear-gradient(135deg, rgba(255,0,0,0.8) 0%, rgba(180,0,0,0.9) 100%)" :
                              "linear-gradient(135deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.9) 100%)",
                        width: "80px",
                        height: "80px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "all 0.3s ease",
                        boxShadow:
                          "0 8px 25px rgba(0, 0, 0, 0.4), 0 0 0 3px rgba(255,255,255,0.3)",
                        border: "none",
                        outline: "none",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform =
                          "translate(-50%, -50%) scale(1.1)";
                        e.target.style.boxShadow =
                          "0 12px 35px rgba(0, 0, 0, 0.6), 0 0 0 4px rgba(255,255,255,0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform =
                          "translate(-50%, -50%) scale(1)";
                        e.target.style.boxShadow =
                          "0 8px 25px rgba(0, 0, 0, 0.4), 0 0 0 3px rgba(255,255,255,0.3)";
                      }}
                    >
                      <i
                        className={getPlatformIcon()}
                        style={{
                          fontSize: "32px",
                          color: "white",
                          marginLeft: "4px",
                        }}
                      ></i>
                    </a>
                  )}
                </div>
              ) : (
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    paddingBottom: "56.25%",
                    overflow: "hidden",
                    background: "#000",
                  }}
                >
                  {platform === "direct" ? (
                    <video
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        border: "none",
                      }}
                      src={videoUrl}
                      controls
                      autoPlay
                    ></video>
                  ) : (
                    <iframe
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        border: "none",
                        pointerEvents: "auto",
                      }}
                      src={getEmbedUrl()}
                      title={`${platform} video player`}
                      frameBorder="0"
                      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                      webkitallowfullscreen="true"
                      mozallowfullscreen="true"
                      sandbox="allow-scripts allow-same-origin allow-presentation"
                    ></iframe>
                  )}

                  {platform === "loom" && (
                    <style>
                      {`
                        iframe[src*="loom.com"] {
                          pointer-events: auto !important;
                        }
                        .loom-embed-watermark,
                        .loom-watermark,
                        .loom-branding,
                        .loom-comments,
                        .loom-comment-panel,
                        .loom-transcript,
                        .loom-captions,
                        .loom-sidebar,
                        [class*="watermark"],
                        [class*="branding"],
                        [class*="comment"],
                        [class*="transcript"],
                        [class*="caption"],
                        [data-testid*="comment"],
                        [data-testid*="transcript"],
                        [data-testid*="caption"] {
                          display: none !important;
                          visibility: hidden !important;
                          opacity: 0 !important;
                          height: 0 !important;
                          width: 0 !important;
                        }
                      `}
                    </style>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

UniversalVideoPlayer.propTypes = {
  videoUrl: PropTypes.string.isRequired,
  isIlanDetay: PropTypes.bool,
};

export default UniversalVideoPlayer;
